var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 138,
    height: 138,
    viewBox: "0 0 138 138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_374",
    x: 0,
    y: 0,
    width: 138,
    height: 138,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5930",
    "data-name": "Group 5930",
    transform: "translate(-1464 522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KRUG",
    transform: "translate(1473 -516)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Ellipse_374)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_374-2",
    "data-name": "Ellipse 374",
    cx: 60,
    cy: 60,
    r: 60,
    transform: "translate(9 6)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file",
    transform: "translate(1466.844 -486.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5908",
    "data-name": "Group 5908",
    transform: "translate(40.097)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5907",
    "data-name": "Group 5907",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8076",
    "data-name": "Path 8076",
    d: "M90.18,8.347H84.868V3.035A3.044,3.044,0,0,0,81.833,0h-38.7A3.044,3.044,0,0,0,40.1,3.035V51.6a3.044,3.044,0,0,0,3.035,3.035h5.312v5.312a3.044,3.044,0,0,0,3.035,3.035h25.8a8.856,8.856,0,0,0,5.245-2.08L91,52.922a8.059,8.059,0,0,0,2.21-5.115V11.383A3.045,3.045,0,0,0,90.18,8.347ZM48.444,11.383V52.359H43.132a.769.769,0,0,1-.759-.759V3.035a.769.769,0,0,1,.759-.759h38.7a.769.769,0,0,1,.759.759V8.347H51.479A3.044,3.044,0,0,0,48.444,11.383Zm41,39.882-8.479,7.981a4.028,4.028,0,0,1-.65.476V52.739a1.9,1.9,0,0,1,1.9-1.9H89.8A3.187,3.187,0,0,1,89.443,51.264Zm1.494-3.458a3.539,3.539,0,0,1-.1.759H82.211a4.182,4.182,0,0,0-4.174,4.174v7.876a3.969,3.969,0,0,1-.759.092h-25.8a.768.768,0,0,1-.759-.759V11.382a.768.768,0,0,1,.759-.759h38.7a.769.769,0,0,1,.759.759Z",
    transform: "translate(-40.097 0)",
    fill: "#3a3a3a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5910",
    "data-name": "Group 5910",
    transform: "translate(58.689 18.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5909",
    "data-name": "Group 5909"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8077",
    "data-name": "Path 8077",
    d: "M214.379,154.216H192.373a1.138,1.138,0,1,0,0,2.277h22.006a1.138,1.138,0,0,0,0-2.277Z",
    transform: "translate(-191.235 -154.216)",
    fill: "#508932"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5912",
    "data-name": "Group 5912",
    transform: "translate(58.689 34.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5911",
    "data-name": "Group 5911"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8078",
    "data-name": "Path 8078",
    d: "M214.379,277.59H192.373a1.138,1.138,0,1,0,0,2.276h22.006a1.138,1.138,0,1,0,0-2.276Z",
    transform: "translate(-191.235 -277.59)",
    fill: "#508932"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5914",
    "data-name": "Group 5914",
    transform: "translate(58.689 41.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5913",
    "data-name": "Group 5913"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8079",
    "data-name": "Path 8079",
    d: "M204.515,339.277H192.374a1.138,1.138,0,1,0,0,2.277h12.141a1.138,1.138,0,0,0,0-2.277Z",
    transform: "translate(-191.236 -339.277)",
    fill: "#508932"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5916",
    "data-name": "Group 5916",
    transform: "translate(58.689 26.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5915",
    "data-name": "Group 5915"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8080",
    "data-name": "Path 8080",
    d: "M214.379,215.9H192.373a1.138,1.138,0,1,0,0,2.276h22.006a1.138,1.138,0,0,0,0-2.276Z",
    transform: "translate(-191.235 -215.903)",
    fill: "#508932"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.0755718df73aff8c67361f4eb9a98da5.svg";
export { ForwardRef as ReactComponent };